import { inject, Injectable } from '@angular/core';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(pageNumber: number, pageSize: number, key?: string, value?: string) {
    let params = '';

    if (key) params += `&key=${key}`;
    if (value) params += `&value=${value}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/parameters?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/parameters/' + id
    );
  }

  updateValue(id: string, value: string) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/parameters/${id}/value`,
      { value }
    );
  }
}
